const pctPattern = /^-?\d{1,2}(\.\d{1,2})?$/;
function decimal(value) {
    if (!/^-?\d+(\.\d+)?$/.test(value)) return null;
    const [whole, fraction = ''] = value.split('.');
    const sign = whole.startsWith('-') ? -BigInt(1) : BigInt(1);
    return {
        units: sign * BigInt(whole.replace('-', '') + fraction),
        scale: BigInt(10) ** BigInt(fraction.length)
    };
}
/** Resolve one team policy; always calculate from Suggested, never another adjustment. */ export function applyCompetitiveAdjustment(suggested, requiresChoice, adjustments, categoryKey, periodKey) {
    const empty = {
        adjusted: '',
        applied: null
    };
    const amount = decimal(suggested);
    if (!amount || requiresChoice) return empty;
    let applied = null;
    let rank = 0;
    for (const entry of adjustments){
        if (!pctPattern.test(entry.pct)) continue;
        const pct = Number(entry.pct);
        if (pct === 0 || Math.abs(pct) > 50) continue;
        let specificity = 0;
        if (entry.scope === 'scenario') specificity = 1;
        if (entry.scope === 'period' && entry.periodKey === periodKey) specificity = 2;
        if (categoryKey && entry.lcatLogicalKey === categoryKey) {
            if (entry.scope === 'category') specificity = 3;
            if (entry.scope === 'cell' && entry.periodKey === periodKey) specificity = 4;
        }
        if (specificity > rank) {
            rank = specificity;
            applied = entry;
        }
    }
    if (!applied) return empty;
    const pct = decimal(applied.pct);
    if (!pct) return empty;
    // Exact rational arithmetic until the one half-up rounding at reported cents.
    const numerator = amount.units * (BigInt(100) * pct.scale + pct.units) * BigInt(100);
    const denominator = amount.scale * BigInt(100) * pct.scale;
    const sign = numerator < BigInt(0) ? -BigInt(1) : BigInt(1);
    const absolute = numerator * sign;
    const cents = (absolute / denominator + (absolute % denominator * BigInt(2) >= denominator ? BigInt(1) : BigInt(0))) * sign;
    const magnitude = cents * sign;
    return {
        adjusted: `${cents < BigInt(0) ? '-' : ''}${magnitude / BigInt(100)}.${String(magnitude % BigInt(100)).padStart(2, '0')}`,
        applied
    };
}
